import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { CertificationService } from './certification.service';
import { AppSettings } from '../../shared/configuration/appsettings.config';


@Injectable()
export class RouteResolver  {

    routeData: Observable<any>;

    constructor(private certificationService: CertificationService) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<any> {

        let tempCertificationId = AppSettings.getCertificationID();
        let refCode: string = AppSettings.getReferenceCode();
        switch (route.data['page']) {
            case "form":
            case "review":
            case "documents":
                this.routeData = this.certificationService.getCertificationData(tempCertificationId, refCode);
                break;

        }
        return this.routeData;
    }
}
